export const citationFragment = `
  fragment citationFields on Citation {
    code
    description
  }
`;
